import React, { useContext, useState } from 'react';
import './Login.css';
import PasswordRecovery from './PasswordRecovery';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { AuthService } from '../../services/AuthService';

function Login({ onLogin }) {
  const { handleLogin } = useContext(AuthContext);
  const [documento, setDocumento] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPasswordRecovery, setShowPasswordRecovery] = useState(false);
  const [documentoError, setDocumentoError] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setDocumentoError('');
    setPasswordError('');

    let valid = true;

    if (!documento.trim()) {
      setDocumentoError('Número de documento es obligatorio');
      valid = false;
    }

    if (!password.trim()) {
      setPasswordError('Contraseña es obligatorio');
      valid = false;
    }

    if (!valid) return;

    try {
      const res = await AuthService.login({ documento, password });
      const { success, message } = res;
      if (success) {
        handleLogin(res);
      } else {
        setPasswordError(message || 'Credenciales incorrectas');
      }
    } catch (err) {
      if (err.response) {
        const status = err.response.status;
        const mensaje = err.response.data?.message;

        if (status === 401) {
          // Mensaje personalizado desde el backend
          setPasswordError(mensaje || 'Credenciales incorrectas');
        } else {
          setPasswordError(mensaje || 'Error inesperado al iniciar sesión');
        }
      } else if (err.request) {
        setPasswordError('No se pudo conectar con el servidor');
      } else {
        setPasswordError('Error desconocido');
      }
    }
  };

  return (
    <div className="login-bg">
      <form className="login-box" onSubmit={handleSubmit}>
        <div className="login-logo">
          <img src="/logo_login.png" alt="Logo" className="logo-image" />
        </div>

        <input
          type="text"
          placeholder="Número de documento"
          value={documento}
          onChange={e => setDocumento(e.target.value)}
          autoFocus
          className={!documentoError ? 'input-mg' : ''}
        />
        {documentoError && <div className="error">{documentoError}</div>}


        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={e => setPassword(e.target.value)}
          className={!passwordError ? 'input-mg' : ''}
        />
        {passwordError && <div className="error">{passwordError}</div>}

        <button type="submit" className="login-btn">Ingresar</button>
        <div className="login-link">
          <Link to="/recuperar-clave" className="recovery-link">
            Recuperar clave
          </Link>
        </div>
      </form>

      {showPasswordRecovery && (
        <PasswordRecovery
          onClose={() => setShowPasswordRecovery(false)}
          onBackToLogin={() => setShowPasswordRecovery(false)}
        />
      )}
    </div>
  );
}

export default Login; 
